import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FlowZoom } from 'ui/workflows/flowchart';
import { openModal, getWorkflowType } from 'modules/workflows/ducks';
import { ALIGN_NODES_MODAL } from 'modules/workflows/constants';
import { FloatingActionsWrapper } from '../Footer.styles';
import NoteVisibilityToggleButton from './NoteVisibilityToggleButton';
import { AlignAllTilesButton } from './AlignAllTilesButton';

export const FloatingFooterActions = () => {
  const { isPublished } = useSelector(getWorkflowType);
  const dispatch = useDispatch();
  const handleAlignNodes = useCallback(
    (modalProps: any) => dispatch(openModal(ALIGN_NODES_MODAL, modalProps)),
    [],
  );

  return (
    <FloatingActionsWrapper>
      <FlowZoom />
      <NoteVisibilityToggleButton />
      {!isPublished && <AlignAllTilesButton onAlignNodes={handleAlignNodes} />}
    </FloatingActionsWrapper>
  );
};

export default FloatingFooterActions;
